import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

const ThemeContext = createContext(undefined);

export const ACCENTS = [
  { id: 'emerald', color: '#059669', es: 'Esmeralda', en: 'Emerald' },
  { id: 'blue', color: '#2563eb', es: 'Azul', en: 'Blue' },
  { id: 'purple', color: '#7c3aed', es: 'Morado', en: 'Purple' },
  { id: 'gold', color: '#d97706', es: 'Dorado', en: 'Gold' },
  { id: 'red', color: '#dc2626', es: 'Rojo', en: 'Red' }
];

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('metodo11_theme_mode') || 'light');
  const [accent, setAccent] = useState(() => localStorage.getItem('metodo11_theme_accent') || 'emerald');

  useEffect(() => {
    localStorage.setItem('metodo11_theme_mode', mode);
    document.documentElement.classList.toggle('dark-app', mode === 'dark');
  }, [mode]);

  useEffect(() => {
    localStorage.setItem('metodo11_theme_accent', accent);
    document.documentElement.setAttribute('data-accent', accent);
  }, [accent]);

  const value = useMemo(() => ({ mode, setMode, accent, setAccent }), [mode, accent]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
